"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDocumentCommand = exports.ClearDocumentCommand = exports.SetDocumentNameCommand = exports.SetDocumentDescriptionCommand = exports.CreateDocumentCommand = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
exports.CreateDocumentCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.createDocumentCommand),
    data: zod_1.z.custom(),
});
exports.SetDocumentDescriptionCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.setDocumentDescriptionCommand),
    description: zod_1.z.string(),
});
exports.SetDocumentNameCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.setDocumentNameCommand),
    name: zod_1.z.string(),
});
/**
 * Command to clear all document data (PCB layout nodes and rule sets).
 *
 * NOTE: This command should NOT be persisted. It is just a frontend command that helps
 * synchronize events/commands that happen to the document in the right order.
 */
exports.ClearDocumentCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.clearDocumentCommand),
});
/**
 * Command to modify the base document. We have this "base document" concept from the fact that
 * in Firestore we store document data in one Firestore document (which is what we called "base document"),
 * and then for each sub-collection of the document, we store its data in a different Firestore document.
 *
 * Commands defined here are supposed to ONLY mutate the "base document" data
 */
exports.BaseDocumentCommand = zod_1.z.discriminatedUnion("type", [
    exports.SetDocumentDescriptionCommand,
    exports.SetDocumentNameCommand,
    exports.ClearDocumentCommand,
    exports.CreateDocumentCommand,
]);
//# sourceMappingURL=baseDocument.js.map